import isEmail from 'validator/lib/isEmail';

const ServiceValidation = {

	validateEtapeProduitDetails: function(commande) {

		let validation = {
			isValid: true,
			messageErreur: null,
			contact: false
		};

		if (commande.quantiteTotale < 1) {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: "Vous devez selectionner <b>au moins un élément à entretenir</b> pour passer à l'étape suivante." };
		}
		else if (commande.dureeTotale > 600) {
			validation = { ...validation, isValid: false };
			validation = {
				...validation, messageErreur: "La durée totale de l'intervention ne peut <b>pas dépasser 10 heures.</b>"
					+ "<p>Pour ce type de demande vous pouvez contacter directement notre service client :</p>"
			};
			validation = { ...validation, contact: true };
		}

		return validation;
	},

	validateEtapeAdresseCreneau: function(commande) {

		let validation = {
			isValid: true,
			messageErreur: null
		};

		if (commande.commune === undefined || commande.commune === null) {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Commune / Code postal") };
		}
		else if (commande.adresse === null || commande.adresse === '') {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Adresse de l'intervention") };
		}
		else if (commande.adresse.length > 80) {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: getMessageErreurTailleMax(commande.adresse, "Adresse de l'intervention", 80) };
		}

		return validation;
	},

	validateRechercheCreneaux: function(resultat) {

		let validation = {
			isValid: true,
			messageErreur: null
		};

		if (resultat.statut === 1) {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: resultat.message };
		}

		return validation;
	},

	validateEtapeDevisPaiement: function(commande) {

		let validation = validateInfosEntreprise(commande);
		if (!validation.isValid)
			return validation;

		validation = validateInfosPrenomNom(commande);
		if (!validation.isValid)
			return validation;

		validation = validateInfosTelephone(commande);
		if (!validation.isValid)
			return validation;

		validation = validateInfosEmail(commande);
		if (!validation.isValid)
			return validation;
		
		validation = validateCGV(commande);
		if (!validation.isValid)
			return validation;

		return validation;
	}

}
export default ServiceValidation;

var validateInfosEntreprise = (commande) => {

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.clientType === 'entreprise') {
		if (commande.clientNomEntreprise === null || commande.clientNomEntreprise === '') {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Nom de l'entreprise") };
		}
		else if (commande.clientNomEntreprise > 60) {
			validation = { ...validation, isValid: false };
			validation = { ...validation, messageErreur: getMessageErreurTailleMax(commande.clientNomEntreprise, "Nom de l'entreprise", 60) };
		}
	}

	return validation;
}

var validateInfosPrenomNom = (commande) => {

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.contactPrenom === null || commande.contactPrenom === '') {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Prénom") };
	}
	else if (commande.contactPrenom > 40) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurTailleMax(commande.contactPrenom, "Prénom", 40) };
	}
	else if (commande.contactNom === null || commande.contactNom === '') {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Nom") };
	}
	else if (commande.contactNom > 40) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurTailleMax(commande.contactNom, "Nom", 40) };
	}

	return validation;
}

var validateInfosTelephone = (commande) => {

	let PHONE_REGEX = new RegExp(/^((\+)33|0)[1-9](\d{2}){4}$/);

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.contactTelephoneMobile === null || commande.contactTelephoneMobile === '') {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Téléphone Mobile") };
	}
	else if (!PHONE_REGEX.test(commande.contactTelephoneMobile)) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurNumeroTelephone(commande.contactTelephoneMobile, "Téléphone Mobile") };
	}

	return validation;
}

var validateInfosEmail = (commande) => {

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.contactEmail === null || commande.contactEmail === '') {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Adresse e-mail") };
	}
	else if (!isEmail(commande.contactEmail)) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurEmail(commande.contactEmail, "Adresse e-mail") };
	}
	else if (commande.contactEmail !== commande.contactEmailConfirmation) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurEgalite("Adresse e-mail", "Confirmation adresse e-mail") };
	}

	return validation;
}

var validateCGV = (commande) => {

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.acceptCGV === null || commande.acceptCGV !== true) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurAcceptCGVObligatoire() };
	}
	
	return validation;
}

/**
var validateInfosFacturation = (commande) => {

	let validation = {
		isValid: true,
		messageErreur: null
	};

	if (commande.communeFacturation === undefined || commande.communeFacturation === null) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Commune / Code postal facturation") };
	}
	else if (commande.adresseFacturation === null || commande.adresseFacturation === '') {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurChampObligatoire("Adresse complète facturation") };
	}
	else if (commande.adresseFacturation.length > 80) {
		validation = { ...validation, isValid: false };
		validation = { ...validation, messageErreur: getMessageErreurTailleMax(commande.adresseFacturation, "Adresse complète facturation", 80) };
	}

	return validation;
}
*/

var getMessageErreurChampObligatoire = (labelChamp) => {
	return "Vous devez renseigner le champ <b>" + labelChamp + "</b> pour passer à l'étape suivante."
}

var getMessageErreurAcceptCGVObligatoire = () => {
	return "Vous devez accepter <b>les conditions générales de vente</b> pour passer à l'étape suivante."
}

var getMessageErreurTailleMax = (champ, labelChamp, tailleMax) => {
	return "La taille du champ <b>" + labelChamp + "</b> ne doit pas dépasser <b>" + tailleMax + "</b> caractères."
		+ "<br />Taille actuelle : <b>" + champ.length + "</b>";
}

var getMessageErreurNumeroTelephone = (champ, labelChamp) => {
	return "La valeur <b>" + champ + "</b> du champ <b>" + labelChamp + "</b> ne correspond pas à un numéro de téléphone valide.";
}

var getMessageErreurEmail = (champ, labelChamp) => {
	return "La valeur <b>" + champ + "</b> du champ <b>" + labelChamp + "</b> ne correspond pas à un e-mail valide.";
}

var getMessageErreurEgalite = (labelChamp1, labelChamp2) => {
	return "Les valeurs des champs <b>" + labelChamp1 + "</b> et <b>" + labelChamp2 + "</b> ne sont pas identiques.";
}